import { render } from "./referee-login.vue?vue&type=template&id=545b7082&scoped=true"
import script from "./referee-login.vue?vue&type=script&lang=js"
export * from "./referee-login.vue?vue&type=script&lang=js"

import "./referee-login.vue?vue&type=style&index=0&id=545b7082&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545b7082"]])

export default __exports__